import {
  applyForDip,
  canDoDip,
  canDoDipNoProperty,
  doFMA,
  doSolicitorSearch,
  getDipCert,
  getDipStatus,
  getDoc,
  getFMAFields,
  submitDip,
  submitNoPropertyDip,
} from '../api/dip'
import { DipApplicationError, FmaFieldsResponse, Resolvers } from '../generated/resolvers'

const resolvers: Resolvers = {
  Mutation: {
    submitDip: async (_parent, { payloadInput, queryInput }) => await submitDip(payloadInput, queryInput),
    submitNoPropertyDip: async (_parent, { payloadInput, queryInput }) =>
      await submitNoPropertyDip(payloadInput, queryInput),
    getDipCert: async (_parent, { id, mortgageId, case: _case }) => await getDipCert(id, _case, mortgageId),
    getDipDocument: async (_parent, { id, mortgageId, case: _case, documentType: documentType }) =>
      await getDoc(id, _case, mortgageId, documentType!),
    doFMA: async (_parent, { input }) => await doFMA(input),
  },
  Query: {
    canDoDip: async (_parent, { input }) => await canDoDip(input),
    canDoDipNoProperty: async (_parent, { input }) => await canDoDipNoProperty(input),
    getDipStatus: async (_parent, { input }) => await getDipStatus(input),
    applyForDip: async (_parent, { id, mortgageId, reservation }) => await applyForDip(id, mortgageId, reservation),
    fmaFields: async (_parent, { caseId, mortgageId }) => await getFMAFields(caseId, mortgageId),
    solicitorSearch: async (_parent, { q }) => await doSolicitorSearch(q),
  },
  FMAFields: {
    __resolveType(obj) {
      if ((obj as FmaFieldsResponse).dip_available) {
        return 'FMAFieldsResponse'
      }
      if ((obj as DipApplicationError).errors) {
        return 'DipApplicationError'
      }
      return null
    },
  },
  FMAResponse: {
    __resolveType(obj) {
      if ((obj as DipApplicationError).errors) {
        return 'DipApplicationError'
      }
      return 'ApplicationResponse'
    },
  },
}

export default resolvers
